<template>
  <div class="row px-4">
    <div class="form-group col-md-6 offset-md-3 col-sm-12" data-aos="fade-right" data-aos-duration="1500" data-aos-delay="200">
      <question
        v-model="applicationData.auth"
        :label="$t('questions.auth')"
        name="auth"
        :options="localizedYesNo"
        :readonly="readonly"
        :error="errors.AUTH"
      />
    </div>
    <div class="form-group col-md-6 offset-md-3 col-sm-12" data-aos="fade-left" data-aos-duration="1500" data-aos-delay="200">
      <question
        v-model="applicationData.transportation"
        :label="$t('questions.transportation')"
        name="transportation"
        :readonly="readonly"
        :error="errors.TRANSPORTATION"
        :options="localizedTransportationOptions"
        :stacked="true"
        />
    </div>
    <div class="form-group col-md-6 offset-md-3 col-sm-12" data-aos="fade-right" data-aos-duration="1500" data-aos-delay="200">
      <question
        v-model="applicationData.paid_experience"
        :label="$t('questions.paid_experience')"
        name="paid_experience"
        :readonly="readonly"
        :error="errors.PAID_EXPERIENCE"
        :options="localizedPaidOptions"
        :stacked="true"
        :rules="{ is_not:'Never been paid before to clean', required: true }"
      />
    </div>
    <more-info />
  </div>
</template>
<script>
import '@/shared/validations.js'
import Vue from 'vue'
import Question from '@/shared/fields/cleaner_app_form_question.vue'
import MoreInfo from './more_info.vue'

export default {
  components: {
    Question, MoreInfo
  },
  props: {
    readonly: {
      type: Boolean,
      required: true
    },
    applicationData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      loading: true,
      errors: $errors,
      options: $options
    }
  },
  computed: {
    localizedYesNo() {
      return [ this.$t('yes'), this.$t('no') ]
    },
    localizedPaidOptions() {
      let options = []
      this.options.PAID_EXPERIENCE.forEach((key) => {
        options.push(this.$t('options.paid_experience.' + key))
      })
      return options
    },
    localizedTransportationOptions() {
      let options = []
      this.options.TRANSPORTATION.forEach((key) => {
        options.push(this.$t('options.transportation.' + key))
      })
      return options
    }
  },
  methods: {

  }
}
</script>
